import React, { useEffect, useRef, useState } from 'react';
import './OdColHighlight.scss';
import Slider from 'react-slick';
import { useDispatch, useSelector } from 'react-redux';
import { getClickCategory } from '../../../../actionCreators/home';
import OdButton from '../../OdButton/OdButton';

const OdColHighlight = ({ data, device = 'desktop' }) => {
  const sliderRef = useRef(null);
  const { collection, title, description, cta, ctaLink } = data;
  const clickCategoryData = useSelector(state => state.home?.clickCategory);
  const [clickCategory, setClickCategory] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    if (clickCategory && clickCategoryData.data && clickCategoryData.data.urlPath) {
      window.location.href = `/sg/en/${clickCategoryData.data.urlPath}`;
    }
  }, [clickCategory, clickCategoryData]);

  const handleClick = catId => {
    setClickCategory(true);
    dispatch(getClickCategory(catId));
  };

  const config = {
    arrows: false,
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    centerMode: true,
    centerPadding: '20%',
    autoplay: true,
    autoplaySpeed: 5000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const customShouldDisplay = title => {
    const now = new Date();
    const releaseTime = new Date('2025-06-20T10:00:00+08:00');
    const isPreProd = process.env.ENVIRONMENT === 'preprod';
    let shouldDisplay = true;

    if (title === `SQUID GAME × OWNDAYS`) {
      if (isPreProd) {
        return true;
      }
      const isBeforeRelease = now < releaseTime;
      if (isBeforeRelease) shouldDisplay = !isBeforeRelease;

      return shouldDisplay;
    }

    return true;
  };

  return (
    <div className="odCollection">
      <h3 className="odCollection__title">{title}</h3>
      <p className="odCollection__description">{description}</p>
      <div className="odCollection__slider">
        <Slider ref={sliderRef} {...config}>
          {collection?.length > 0 &&
            collection.map(
              (col, index) =>
                customShouldDisplay(col?.alt) && (
                  <a key={index} className="odCollection__card" href={col?.link}>
                    <img
                      alt={col?.alt}
                      className="odCollection__image"
                      src={col.imgSrc}
                      // onClick={() => handleClick(col.catId)}
                    />
                  </a>
                )
            )}
        </Slider>
      </div>
      <div className="odCollection__cta">
        <OdButton href={ctaLink} label={cta} />
      </div>
      {device === 'mobile' ? <div className="odCollection__mobileBorder" /> : null}
    </div>
  );
};

export default OdColHighlight;
